module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Among the Fair Magnolias: Four Southern: Love Stories")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "sec-7"
    }
  }, [_c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "Azc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images/img-7-1.jpg",
      "id": "pz7-1",
      "src": "images/img-7-1.jpg"
    }
  }), _vm._v("CONTENTS"), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images/img-7-2.jpg",
      "id": "AMgx",
      "src": "images/img-7-2.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/dedication01"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#con1",
      "id": "toc1"
    }
  }, [_vm._v("A Note from the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02#con2",
      "id": "toc2"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#con3",
      "id": "toc3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#con4",
      "id": "toc4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#con5",
      "id": "toc5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#con6",
      "id": "toc6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#con7",
      "id": "toc7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#con8",
      "id": "toc8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#con9",
      "id": "toc9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter57#con56",
      "id": "toc56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter56#con55",
      "id": "toc55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter55#con54",
      "id": "toc54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recipe")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter58#con57",
      "id": "toc57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 63
// module chunks = 0